define.alias("shared/utils/social-profile-link", "settings/utils/social-profile-link");